import React from 'react';
import { useHistory } from 'react-router-dom';

import { routeHelper } from 'src/app/helpers';
import { LoginLayoutPropsType } from 'src/app/layouts/LoginLayout/login-layout.config';

import styles from 'src/app/layouts/LoginLayout/LoginLayout.module.scss';

const LoginPage: React.FC<LoginLayoutPropsType> = ({ children }) => {
  const history = useHistory();

  const handleOnClickLogo = () => {
    routeHelper.handleRoute(history, '/');
  };

  return (
    <div className={styles.container}>
      <div
        style={{
          background: 'url(/assets/loginBackground.png)',
          backgroundRepeat: 'repeat',
          backgroundSize: 'cover',
        }}
        className={styles.leftSection}
      >
        <div className={styles.formContainer}>
          <div className={styles.formWrapper}>{children}</div>
        </div>
      </div>
      {/* <div className={styles.rightSection}>
        <img className={styles.loginImage} src="login.svg" alt="login" />
      </div> */}
    </div>
  );
};

export default LoginPage;
